import { size } from "lodash";
import { formatDateForDisplay } from "../../Utils/UtilityFunctions";
import StatusBadge from "../../Customers/StatusBadge";

export const Chargingcoloumn = () => {
  const Chargingcoloumns = [
    // {
    //     accessorKey: "stationId",
    //     header: "Station ID"
    // },
    {
      accessorKey: "stationName",
      header: "Station Name",
    },
    // {
    //     accessorKey: "stationAddress",
    //     header: "Station Address"
    // },
    {
      accessorKey: "eventId",
      header: "Event ID",
    },
    // {
    //     accessorKey: "paymentCreatedAt",
    //     header: "Payment Created At",
    //     Cell: ({ cell }) => formatDateForDisplay(cell.getValue(), "hh:mm A"),

    // },
    {
      accessorKey: "chargingCompletedAt",
      header: "Charging Completed At",
      Cell: ({ cell }) => formatDateForDisplay(cell.getValue(), "hh:mm A"),
    },
    {
      accessorKey: "deductedAmount",
      header: "Deducted Amount",
      Cell: ({ cell, row }) => {
        const amount = cell.getValue(); // assuming paise to rupees
        const currency = row.original.currency || "INR";

        return new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: currency,
        }).format(amount);
      },
    },

    {
      accessorKey: "chargingStatus",
      header: "Charging Status",
      Cell: ({ cell }) => {
        let statusValue = cell.getValue();
        return <StatusBadge value={statusValue} />;
      },
    },
  ];
  return Chargingcoloumns;
};
